// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-popup {
  position: fixed;
  right: 1rem;       /* Sağdan 16px */
  bottom: 4rem;      /* Alttan 32px (önce 2.5rem = 40px idi, %10 yukarı kaydırıldı) */
  max-width: 280px;
  background-color: #3c4f58; /* Mavi (Tailwind'deki blue-600) */
  color: white;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem; /* 8px */
  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.4),
              0 4px 6px -2px rgba(37, 99, 235, 0.1);
  cursor: pointer;
  z-index: 9999;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  transition: transform 0.2s ease-in-out;
}

.notification-popup:hover {
  transform: scale(1.05);
}

.notification-popup h4 {
  font-weight: 700;
  margin-bottom: 0.25rem; /* 4px */
  font-size: 1.125rem; /* 18px */
}

.notification-popup p {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem; /* 20px */
  margin: 0;
}

.notification-popup button.close-btn {
  position: absolute;
  top: 0.25rem;    /* 4px */
  right: 0.5rem;   /* 8px */
  background: transparent;
  border: none;
  color: white;
  font-size: 1.25rem; /* 20px */
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.notification-popup button.close-btn:hover {
  color: #d1d5db; /* Tailwind gray-300 */
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationPopup/NotificationPopup.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW,QAAQ,gBAAgB;EACnC,YAAY,OAAO,gEAAgE;EACnF,gBAAgB;EAChB,yBAAyB,EAAE,kCAAkC;EAC7D,YAAY;EACZ,qBAAqB;EACrB,qBAAqB,EAAE,QAAQ;EAC/B;mDACiD;EACjD,eAAe;EACf,aAAa;EACb,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB,EAAE,QAAQ;EAChC,mBAAmB,EAAE,SAAS;AAChC;;AAEA;EACE,mBAAmB,EAAE,SAAS;EAC9B,oBAAoB,EAAE,SAAS;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY,KAAK,QAAQ;EACzB,aAAa,IAAI,QAAQ;EACzB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE,SAAS;EAC7B,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC","sourcesContent":[".notification-popup {\r\n  position: fixed;\r\n  right: 1rem;       /* Sağdan 16px */\r\n  bottom: 4rem;      /* Alttan 32px (önce 2.5rem = 40px idi, %10 yukarı kaydırıldı) */\r\n  max-width: 280px;\r\n  background-color: #3c4f58; /* Mavi (Tailwind'deki blue-600) */\r\n  color: white;\r\n  padding: 1rem 1.25rem;\r\n  border-radius: 0.5rem; /* 8px */\r\n  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.4),\r\n              0 4px 6px -2px rgba(37, 99, 235, 0.1);\r\n  cursor: pointer;\r\n  z-index: 9999;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.notification-popup:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.notification-popup h4 {\r\n  font-weight: 700;\r\n  margin-bottom: 0.25rem; /* 4px */\r\n  font-size: 1.125rem; /* 18px */\r\n}\r\n\r\n.notification-popup p {\r\n  font-size: 0.875rem; /* 14px */\r\n  line-height: 1.25rem; /* 20px */\r\n  margin: 0;\r\n}\r\n\r\n.notification-popup button.close-btn {\r\n  position: absolute;\r\n  top: 0.25rem;    /* 4px */\r\n  right: 0.5rem;   /* 8px */\r\n  background: transparent;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.25rem; /* 20px */\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.notification-popup button.close-btn:hover {\r\n  color: #d1d5db; /* Tailwind gray-300 */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
